import { NFe } from "@models/NFe";
import { NFCe } from "@models/nfce/NFCe";
import { formatToCEP, formatToCNPJ, formatToCPF } from "@utils/formatters";

interface NfeTabProps {
    activeNFe: NFe | NFCe
}

export function WithdrawalTab({ activeNFe }: NfeTabProps) {

    const {
        cpais, xpais, uf,
        cep, cmun, xmun,
        xbairro, xlgr, nro,
        xcpl,
        xnome, email, fone,
        cnpj, cpf, ie,
    } = activeNFe.infNfe?.retirada || {};


    return <>
        <aside className={['bottom-frame', 'edit-border', 'visible'].join(' ')}>

            <div className="content">

                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Razão Social ou Nome do Expedidor</span>
                        <input type="text" value={xnome ?? ''} disabled={true} />
                    </div>
                </div>

                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>E-mail</span>
                        <input type="text" value={email ?? ''} disabled={true} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Telefone</span>
                        <input type="text" value={fone ?? ''} disabled={true} />
                    </div>
                </div>

                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>CNPJ</span>
                        <input type="text" value={(cnpj && formatToCNPJ(cnpj)) ?? ''} disabled={true} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>CPF</span>
                        <input type="text" value={(cpf && formatToCPF(cpf)) ?? ''} disabled={true} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Inscrição Estadual</span>
                        <input type="text" value={ie ?? ''} disabled={true} />
                    </div>
                </div>

                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '30%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Código de Pais</span>
                        <input type="text" value={cpais ?? ''} disabled={true} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Nome do país</span>
                        <input type="text" value={xpais ?? ''} disabled={true} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Sigla da UF</span>
                        <input type="text" value={uf ?? ''} disabled={true} />
                    </div>
                </div>

                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '50%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>CEP</span>
                        <input type="text" value={formatToCEP(cep ?? '')} disabled={true} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '30%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Código do município</span>
                        <input type="text" value={cmun ?? ''} disabled={true} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Nome do município</span>
                        <input type="text" value={xmun ?? ''} disabled={true} />
                    </div>
                </div>

                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Logradouro</span>
                        <input type="text" value={xlgr ?? ''} disabled={true} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '30%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Número</span>
                        <input type="text" value={nro ?? ''} disabled={true} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '75%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Bairro</span>
                        <input type="text" value={xbairro ?? ''} disabled={true} />
                    </div>
                </div>

                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Complemento</span>
                        <input type="text" value={xcpl ?? ''} disabled={true} />
                    </div>
                </div>

            </div>
        </aside>
    </>;
}